import { AvailableLanguages, DeprecatedPathsType } from '../types/types'
import { PRODUCTION_ENVIRONMENT } from '../utils/enums'
import { PAGE_LINKS } from '../utils/helper'
import Paths from './paths'

export const DeprecatedPaths: DeprecatedPathsType = {
	cs: {
		'/salons/homepage': '/salony/homepage/',
		'/salons/services': '/salony/sluzby/',
		'/salons/services/:categorySlug': '/salony/sluzby/:categorySlug/'
	},
	sk: {
		'/salons/homepage': '/salony/homepage/',
		'/salons/services': '/salony/sluzby/',
		'/salons/services/:categorySlug': '/salony/sluzby/:categorySlug/'
	},
	bg: {
		'/salons/homepage': '/saloni/homepage/',
		'/salons/services': '/saloni/uslugi/',
		'/salons/services/:categorySlug': '/saloni/uslugi/:categorySlug/'
	},
	hu: {
		'/salons/homepage': '/szalonok/homepage/',
		'/salons/services': '/szalonok/szolgaltatasok/',
		'/salons/services/:categorySlug': '/szalonok/szolgaltatasok/:categorySlug/'
	},
	ro: {
		'/salons/homepage': '/saloane/homepage/',
		'/salons/services': '/saloane/servicii/',
		'/salons/services/:categorySlug': '/saloane/servicii/:categorySlug/'
	},
	hr: {
		// NOTE: those paths didn't exist in the past
		'/salons/homepage': '',
		'/salons/services': '',
		'/salons/services/:categorySlug': ''
		// Future deprecated paths...
	},
	'de-AT': {
		// NOTE: those paths didn't exist in the past
		'/salons/homepage': '',
		'/salons/services': '',
		'/salons/services/:categorySlug': ''
		// Future deprecated paths...
	}
}

export const STATIC_PATH_301_REDIRECTS = (locale: AvailableLanguages): Record<PRODUCTION_ENVIRONMENT, Record<string, string>> => {
	// NOTE: deprecated salon slugs based on
	// https://goodrequest.atlassian.net/browse/NOT-15777?focusedCommentId=131338
	const salonDetailRedirects = {
		[`${PAGE_LINKS['/salons/:salonSlug'](locale, 'kerastase-studio-notino-chodov_1')}`]: PAGE_LINKS['/salons/:salonSlug'](
			locale,
			'kerastase-studio-notino-chodov_2'
		),
		[`${PAGE_LINKS['/salons/:salonSlug'](locale, 'affinage-salon-professional')}`]: Paths[locale]['/salons']
	}

	return {
		[PRODUCTION_ENVIRONMENT.PRODUCTION]: {
			...salonDetailRedirects
		},
		[PRODUCTION_ENVIRONMENT.UAT]: {
			...salonDetailRedirects
		},
		[PRODUCTION_ENVIRONMENT.TEST]: {},
		[PRODUCTION_ENVIRONMENT.DEVELOPMENT]: {},
		[PRODUCTION_ENVIRONMENT.LOCAL]: {},
		[PRODUCTION_ENVIRONMENT.STAGING]: {}
	}
}
